import { useState, useEffect } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Avatar, Typography, ListItemText, ListItemAvatar, MenuItem, Button } from '@mui/material';
// components
import Iconify from '../../components/Iconify';
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';
import BadgeStatus from '../../components/BadgeStatus';
import { IconButtonAnimate } from '../../components/animate';
// service
// import { CausesAPI } from '../../services/causes.services';
import { ProjectAPI } from '../../services/projects.services';
import CausesMultiSelect from './CausesMultiSelect';

// ----------------------------------------------------------------------

const ITEM_HEIGHT = 64;
const COLOR_ORANGE = '#FF9E3D';
const COLOR_DARKORANGE = '#FC8D1F';
// ----------------------------------------------------------------------

export default function CausesDesktopDropdown({
  causes,
  selectedCauses,
  setSelectedCauses,
  projects,
  setProjects,
  ...others
}) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleToggle = (value) => () => {
    const currentIndex = selectedCauses.indexOf(value);
    const newChecked = [...selectedCauses];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedCauses(newChecked);
  };

  return (
    <>
      <Button
        variant="contained"
        sx={{
          textTransform: 'none',
          backgroundColor: COLOR_ORANGE,
          borderRadius: '10px',
          justifyContent: 'space-between',
          boxShadow: 0,
          height: 50,
          fontSize: { xs: '1rem !important', md: '1.15rem !important' },
          width: '100%',
          '&:hover': { backgroundColor: COLOR_DARKORANGE },
        }}
        endIcon={
          open ? (
            <Iconify icon={'akar-icons:chevron-up'} color="#ffffff" width={25} height={25} />
          ) : (
            <Iconify icon={'akar-icons:chevron-down'} color="#ffffff" width={25} height={25} />
          )
        }
        onClick={handleOpen}
      >
        Pick a cause that's close to your heart
      </Button>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={anchorEl}
        onClose={handleClose}
        arrow="top-center"
        sx={{
          mt: 1.5,
          ml: 0.75,
          width: 520,
          '& .MuiMenuItem-root': {
            px: 1.5,
            height: ITEM_HEIGHT,
            borderRadius: 0.75,
          },
        }}
      >
        <Scrollbar sx={{ height: { xs: ITEM_HEIGHT * 6, md: ITEM_HEIGHT * 8 } }}>
          <CausesMultiSelect
            causes={causes}
            selectedCauses={selectedCauses}
            setSelectedCauses={setSelectedCauses}
            handleToggle={handleToggle}
          />
        </Scrollbar>
      </MenuPopover>
    </>
  );
}
